
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Link } from 'office-ui-fabric-react/lib/Link';

import Text from '../../common/client/components/Text';

import IfComp from '../common/IfComp';

const classNames = mergeStyleSets({
    root: {
        paddingTop: 4,
        paddingBottom: 4,
        height: 32
    },
    warning: {
        color: '#ff0000'
    }
});

const IsknObjectListStatus = ({data, preparedData, trimmed, onShowAllClick}) => {

    return (
        <Stack horizontal tokens={{childrenGap: 32}} className={classNames.root}>
            <Stack.Item>
                <Text>Vyhledáno {data.length} objektů.</Text>
            </Stack.Item>
            <IfComp cond={trimmed}>
                <Stack.Item className={classNames.warning}>
                    <Text>Zobrzeno pouze prvních {preparedData.length} objektů.</Text>
                </Stack.Item>
                <Stack.Item>
                    <Link onClick={onShowAllClick}>Zobrazit vše</Link>
                </Stack.Item>
            </IfComp>
        </Stack>
    );
}

export default IsknObjectListStatus;
